import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Application')
export class Application {

  @JsonProperty('id', Number)
  id: number = 0;

  @JsonProperty('name', String)
  name: string = '';
}
